import type { SupabaseClient } from '@supabase/supabase-js';

import { supabase } from '../lib/supabase';

// `cockpit_modules` (migration 20261008003000) is not in the generated types yet.
const db = supabase as unknown as SupabaseClient;

/** A cockpit module (`cockpit_modules`, PLAN-GENERICITE § 3.7): the base, or a module that can be switched off. */
export interface CockpitModuleRow {
  readonly slug: string;
  readonly name: string;
  readonly kind: 'socle' | 'module';
  readonly description: string;
  readonly enabled: boolean;
}

/** The modules in their order; an error is returned, never thrown. */
export async function fetchCockpitModules(): Promise<{ ok: true; modules: CockpitModuleRow[] } | { ok: false; error: string }> {
  const { data, error } = await db
    .from('cockpit_modules')
    .select('slug, name, kind, description, enabled')
    .order('sort', { ascending: true });
  if (error) return { ok: false, error: error.message };
  return { ok: true, modules: (data ?? []) as CockpitModuleRow[] };
}

/** Switches a module (`set_cockpit_module_enabled`): its scheduled loops follow; returns how many changed. */
export async function setCockpitModuleEnabled(
  slug: string,
  enabled: boolean,
): Promise<{ ok: true; jobsChanged: number } | { ok: false; error: string }> {
  const { data, error } = await db.rpc('set_cockpit_module_enabled', { p_slug: slug, p_enabled: enabled });
  if (error) return { ok: false, error: error.message };
  const jobs = (data as { jobs_changed?: number } | null)?.jobs_changed;
  return { ok: true, jobsChanged: typeof jobs === 'number' ? jobs : 0 };
}
